<template>
  <crud-form
    v-model="payload"
    :total-group="1"
    :request-class="requestClass"
    :page-title="setPageTitle"
    :override-edit-payload="overrideBeforeEdit"
    :override-create-payload="overrideBeforeCreate"
    :override-set-entity-data="overrideBeforeSetData"
    navigate-back-route="company.list"
    navigate-page-after-save="company.list"
  >
    <template slot="group-1">
      <form-group title="Informações de empresa">
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:nomEmpresa"
              v-model="payload.nomEmpresa"
              :rules="[requiredRule]"
              label="Nome empresa"
              required
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:nomRazaoSocial"
              v-model="payload.nomRazaoSocial"
              :rules="[requiredRule]"
              label="Razão social"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:cnpj"
              v-model="payload.cnpj"
              v-mask="'##.###.###/####-##'"
              :rules="[requiredRule, exactLength(18)]"
              label="CNPJ"
              required
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:codEmpresaTendencia"
              v-model="payload.codEmpresaTendencia"
              label="Código tendência"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="payload.id"
            cols="6"
          >
            <input-text
              id="input:id"
              v-model="payload.id"
              label="Código"
              disabled
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import CompanyRequest from './CompanyRequest';

export default {
  name: 'CompanyForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: CompanyRequest,
    payload: {
      cnpj: '',
      codEmpresaService: '',
      codEmpresaTendencia: '',
      nomEmpresa: '',
      nomRazaoSocial: '',
    },
  }),
  computed: {
    getCompanyId() {
      return this.$route.params.id;
    },
    setPageTitle() {
      return this.getCompanyId ? 'Editar empresa' : 'Adicionar Empresa';
    },
  },
  methods: {
    formatCnpjJustNumbers() {
      return this.payload.cnpj.replace(/[^0-9]/g, '');
    },
    overrideBeforeCreate() {
      return {
        cnpj: this.formatCnpjJustNumbers(),
        codEmpresaService: this.payload.codEmpresaService,
        codEmpresaTendencia: this.payload.codEmpresaTendencia,
        nomEmpresa: this.payload.nomEmpresa,
        nomRazaoSocial: this.payload.nomRazaoSocial,
      };
    },
    overrideBeforeEdit() {
      return {
        cnpj: this.formatCnpjJustNumbers(),
        codEmpresaService: this.payload.codEmpresaService,
        codEmpresaTendencia: this.payload.codEmpresaTendencia,
        nomEmpresa: this.payload.nomEmpresa,
        nomRazaoSocial: this.payload.nomRazaoSocial,
      };
    },
    overrideBeforeSetData(data) {
      return {
        cnpj: this.handleFormatCnpj(data.cnpj),
        codEmpresaService: data.codEmpresaService,
        codEmpresaTendencia: data.codEmpresaTendencia,
        nomEmpresa: data.nomEmpresa,
        nomRazaoSocial: data.nomRazaoSocial,
        id: data.id,
      };
    },
    handleFormatCnpj(cnpj) {
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    },
  },
};
</script>
